export default __webpack_public_path__ + "static/bold-neutrals-dark-6f2b1ecbb62a00299ce06e3cca23dce44cbb46e01d79437b1823eb98fb709d59.png";